/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React, { useState } from 'react';
import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';

const PasteFeaturesModal = ({
    container,
    isOpen,
    onCancel,
    onSelect
}: {
    container: string;
    isOpen: boolean;
    onCancel: Function;
    onSelect: Function;
}) => {
    const [features, setFeatures] = useState<string>('');
    const cancel = () => {
        if (onCancel !== undefined) onCancel();
    };
    const select = () => {
        if (onSelect !== undefined) onSelect(features);
    };
    return (
        <Modal isOpen={isOpen} toggle={cancel} container={container}>
            <ModalHeader toggle={cancel}>Paste Area Selection...</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="featureIds">
                            <b>Paste</b> (CTRL+V) your selection of areas into
                            the box below, then click <b>Select</b> to show them
                            on the map.
                        </Label>
                        <Input
                            rows="10"
                            type="textarea"
                            name="featureIds"
                            id="featureIds"
                            placeholder="Paste your area ids or names here, separated by commas or one per line"
                            value={features}
                            onChange={(evt: any) =>
                                setFeatures(evt.target.value)
                            }
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={select}>
                    Select
                </Button>
                <Button color="secondary" onClick={cancel}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PasteFeaturesModal;
